import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import authService from "../services/authService";

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("checking"); // "checking" | "auth" | "unauth"

  useEffect(() => {
    authService.isAuthenticated().then((ok) => {
      setStatus(ok ? "auth" : "unauth");
    });
  }, []);

  if (status === "checking") {
    // 인증 확인 중 - 빈 화면 (깜빡임 방지)
    return null;
  }

  if (status === "unauth") {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
